import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Shipment} from "../services/shipment";
import {ShipmentEditModalComponent} from "../shipment-edit-modal/shipment-edit-modal.component";

@Component({
    selector: 'app-shipments-modal',
    templateUrl: './shipments-modal.component.html',
    styleUrls: ['./shipments-modal.component.scss']
})
export class ShipmentsModalComponent implements OnInit {

    modal: NgbModalRef;
    shipments: Shipment[] = [];

    constructor(public ngbModal: NgbModal) {
    }

    ngOnInit(): void {
    }

    close() {
        this.modal.close();
    }

    protected showShipment(shipment: Shipment) {
        const modalRef = this.ngbModal.open(ShipmentEditModalComponent, {size: 'xxl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment = shipment;
        modalRef.componentInstance.showAddress = false;
        modalRef.componentInstance.showDriver = true;
    }
}
